import { POSITION } from '@/enums';

export const POSTION_STYLES = {
  [POSITION.TOP]: 'bottom-[calc(100%+1rem)] left-0',
  [POSITION.BOTTOM]: 'top-[calc(100%+1rem)] left-0',
  [POSITION.LEFT]: 'right-[calc(100%+1rem)]',
  [POSITION.RIGHT]: 'left-[calc(100%+1rem)]'
};

export const DEFAULT_COLOR = '#FFFFFFFF';

export const TRANSPARENT_PATTERN_STYLES = {
  backgroundColor: '#fff',
  backgroundImage: `
    linear-gradient(45deg, #e5e5e5 25%, transparent 25%, transparent 75%, #e5e5e5 75%),
    linear-gradient(45deg, #e5e5e5 25%, transparent 25%, transparent 75%, #e5e5e5 75%)
  `,
  backgroundSize: '16px 16px',
  backgroundPosition: '0 0, 8px 8px'
};

export const applyAlphaRules = (prev: string, next: string) => {
  const prevRgb = prev.slice(0, 7);
  const nextRgb = next.slice(0, 7);

  if (prevRgb !== nextRgb) {
    return `${nextRgb}FF`;
  }

  return next;
};
